module.exports = __webpack_public_path__ + "static/media/view.764051a9.png";